export default {
  MAIN_MENU: 'main-menu',
  PUBLISHING_POPUP: 'publishing-popup',
  ANNUAL_SUBSCRIPTION_SELECTED: 'annual-subscription-selected',
};
